<template>
  <div class="banner">
    <div>
      <div class="banner__tags">
        <span class="banner__pill">健康管理一体化工作台</span>
        <span class="banner__live"><i></i>AI引擎实时联动</span>
      </div>
      <h2>一个页面完成会员健康管理全流程</h2>
      <p>报告生成、标签更新、用药管理和方案分配共享同一会员档案，避免重复查询与页面切换。</p>
    </div>
    <div class="banner__stat">
      <span>当前流程完整度</span>
      <strong>{{ flowText }}</strong>
      <em>{{ flowHint }}</em>
    </div>
  </div>
</template>

<script>
/** 顶部横幅：展示当前会员的流程完整度 */
export default {
  name: 'WorkbenchBanner',
  props: {
    flowText: { type: String, default: '--' },
    flowHint: { type: String, default: '0个环节已完成' }
  }
};
</script>
